<template>
  <div class="about-wrap">
    <!-- 头部 -->
    <top></top>
    <!-- 2024.5.21 关于展会 dxm -->
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <img
          v-if="bannerArr.length > 0"
          class="banner"
          :src="$imgUrl+bannerArr[0].thumb"
          alt=""
        />
        <div class="container">
          <!-- 展后概况 -->
          <div class="about-overview">
            <div class="left" v-if="dataList[0] && dataList[0].time">
              BCEIA {{ dataList[0] && dataList[0].time }}<br />
              {{ langSet == "cn" ? "展后概况" : "General Situation" }}
            </div>
            <div
              class="right"
              v-if="
                langSet == 'cn'? dataList[0] && dataList[0].description : dataList[0] && dataList[0].en_description
              "
            >
              {{
                langSet == "cn"
                  ? dataList[0] && dataList[0].description
                  : dataList[0] && dataList[0].en_description
              }}
            </div>
          </div>
          <div
            class="about-number"
            v-if="
              dataList[0] &&
              (dataList[0].area ||
                dataList[0].exhibitor ||
                dataList[0].audience)
            "
          >
            <div class="number-list" v-if="dataList[0] && dataList[0].area">
              <p class="number">{{ dataList[0] && dataList[0].area }}</p>
              <p>{{ langSet == "cn" ? "面积" : "area" }}(m²)</p>
            </div>
            <div
              class="number-list"
              v-if="dataList[0] && dataList[0].exhibitor"
            >
              <p class="number">{{ dataList[0] && dataList[0].exhibitor }}</p>
              <p>{{ langSet == "cn" ? "展商(家)" : "Exhibitor (Home)" }}</p>
            </div>
            <div class="number-list" v-if="dataList[0] && dataList[0].audience">
              <p class="number">{{ dataList[0] && dataList[0].audience }}</p>
              <!-- 25.7.14 隐藏观众人次 杜学萌 李晋京 -->
              <p>
                {{ langSet == "cn" ? "观众" : "Audience" }}
              </p>
            </div>
          </div>
          <!-- 往届数据 -->
          <div class="data" v-if="dataList.length > 0">
            <img class="img" src="../../assets/about_img.jpg" alt="" />
            <div class="data-title">
              BCEIA {{ langSet == "cn" ? "往届数据" : "Previous Data" }}
            </div>
            <div class="data-list">
              <div
                v-for="(item, index) in dataList"
                :key="index"
                @click="sessionHpdetail(item)"
              >
                <p>
                  {{ langSet == "cn" ? item.title : item.en_title
                  }}<i class="el-icon-arrow-right"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 展品范围 -->
        <div
          class="exhibition-scope"
          v-if="productTypeList.length > 0 || newProductTypeList.length > 0"
        >
          <div class="container">
            <h2 class="h2-title">
              {{ langSet == "cn" ? "展品范围" : "Range Of Exhibits" }}
            </h2>
          </div>
          <div class="exhibition">
            <div class="container">
              <div class="ex-list" v-if="productTypeList.length > 0">
                <div
                  class="item"
                  v-for="(items, indexs) in productTypeList"
                  :key="indexs"
                >
                  <p class="en-title">{{ items.name_en }}</p>
                  <p class="title">{{ items.name_cn }}</p>
                  <p class="line"></p>
                  <div class="item-wrap">
                    <div v-for="(item, index) in items.children" :key="index">
                      <p>{{ langSet == "cn" ? item.name_cn : item.name_en }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ex-item" v-if="newProductTypeList.length > 0">
                <p v-for="(item, index) in newProductTypeList" :key="index">
                  {{ langSet == "cn" ? item.name_cn : item.name_en }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { sessionHpLists, getBanner, getproductType } from "@/api/api";

export default {
  components: { top, bottom },
  name: "about",
  // 配置title和meta数据
  metaInfo() {
    return {
      title:this.langSet=='cn'?this.keydata.name_cn:this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      bannerArr: [],
      dataList: [],
      langSet: "",
      productTypeList: [],
      newProductTypeList: [],
      keydata:{}
    };
  },
  created() {},
  activated(){
    let menuArr=JSON.parse(localStorage.getItem('menuArr'))
    console.log(menuArr,"menuArr")
     menuArr.map(item=>{
      if(item.children){
        item.children.map(i=>{
            if(i.name_cn=='关于展会'||i.name_en=='Exhibition'){
                this.keydata=i;
          }
        })
      }
       
     })
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getSessionHpLists();
    this.getBannerList();
    this.getproduct();
  },
  methods: {
    // zhang 获取产品类型
    getproduct() {
      let data = {
        page_no: 1,
        page_size: 1000,
      };
      getproductType(data)
        .then((res) => {
          if (res.code == 1) {
            let productTypeList = [];
            let newProductTypeList = [];
            let lists = res.data.lists;
            lists.map((item, index) => {
              if (item.children) {
                if (productTypeList.length <= 2) {
                  productTypeList.push(item);
                }
              } else {
                newProductTypeList.push(item);
              }
            });
            this.productTypeList = productTypeList;
            this.newProductTypeList = newProductTypeList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 跳转展会概况
    sessionHpdetail(item) {
      this.$router.push({
        path: "/sessionHpdetail/"+item.id,
      });
    },
    // zhang 获取关于展会banner
    getBannerList() {
      let data = {
        class: "关于展会",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSessionHpLists() {
      let data = {};
      sessionHpLists(data)
        .then((res) => {
          if (res.code == 1) {
            this.dataList = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.about-wrap {
  .banner {
    width: 100%;
    display: block;
  }
  .container {
    padding-top: 80px;
    .about-overview {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
      margin-bottom: 50px;
      .left {
        font-size: 56px;
        color: #243889;
        line-height: 68px;
        margin-right: 186px;
        font-family: Impact;
      }
      .right {
        flex: 1;
        font-weight: 400;
        font-size: 16px;
        color: #1c1c1e;
        line-height: 22px;
      }
    }
    .about-number {
      width: 100%;
      height: 422px;
      display: flex;
      justify-content: flex-end;
      padding: 71px 77px 0 0;
      box-sizing: border-box;
      background: url("../../assets/about_bg.png") no-repeat;
      background-size: 100% 100%;
      margin-bottom: 92px;
      .number-list {
        font-size: 20px;
        color: #243889;
        font-weight: 500;
        line-height: 28px;
        margin-left: 108px;
        text-align: center;
        .number {
          font-family: SFPro, SFPro;
          font-weight: 900;
          font-size: 48px;
          line-height: 58px;
        }
      }
    }
    .data {
      padding: 10px 10px 20px;
      overflow: hidden;
      min-height: 423px;
      background: #fff;
      border-radius: 15px;
      margin-bottom: 40px;
      box-sizing: border-box;
      border: 2px solid #243889;
      .img {
        width: 100%;
        border-radius: 14px;
      }
      .data-title {
        font-size: 20px;
        color: #243889;
        font-weight: 600;
        line-height: 28px;
        padding: 20px 50px 0;
      }
      .data-list {
        display: flex;
        flex-wrap: wrap;
        font-size: 18px;
        font-weight: 500;
        color: #243889;
        line-height: 25px;
        padding: 0 50px;
        p {
          margin-top: 15px;
          cursor: pointer;
          margin-right: 168px;
          &:hover {
            text-decoration: underline;
          }
          i {
            margin-left: 15px;
          }
        }
      }
    }
  }
  .exhibition-scope {
    .exhibition {
      // height: 364px;
      margin-top: 283px;
      padding-bottom: 90px;
      box-sizing: border-box;
      background: #243889;
      .ex-list {
        // height: 364px;
        display: flex;
        // flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        margin-top: -300px;
        margin-bottom: 50px;
        .item {
          width: 400px;
          // height: 303px;
          background: #fff;
          padding: 20px 28px 20px 30px;
          box-sizing: border-box;
          box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.08);
          font-weight: 500;
          .en-title {
            font-size: 18px;
            color: #18a8fc;
            line-height: 25px;
          }
          .title {
            font-size: 18px;
            color: #243889;
            line-height: 25px;
          }
          .line {
            width: 60px;
            height: 2px;
            margin-top: 8px;
            background: #07a1fb;
          }
          .item-wrap {
            display: flex;
            flex-wrap: wrap;
            font-weight: 400;
            font-size: 16px;
            color: #243889;
            line-height: 22px;
            margin-top: 20px;
            > div {
              width: 50%;
              p {
                margin-bottom: 15px;
              }
            }
          }
        }
        .item:nth-child(2) {
          // height: 384px;
        }
      }
      .ex-item {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        line-height: 25px;
        p {
          padding: 0 13px;
          margin-bottom: 20px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .about-wrap .banner{
    margin-top: 0.88rem;
  }
  .ex-list {
    flex-wrap: wrap;
    justify-content: center !important;
    margin-top: 0 !important;
    margin-bottom: 15px !important;
    .item {
      margin-bottom: 20px !important;
      .item-wrap {
        line-height: 18px !important;
      }
    }
  }
  .about-wrap .exhibition-scope .exhibition {
    margin-top: 20px !important;
    padding-bottom: 31px !important;
  }
  .about-wrap .container {
    padding-top: 40px;
    .data {
      min-height: 375px;
      margin-bottom: 0;
      .data-title {
        font-size: 20px !important;
      }
      .data-list {
        font-size: 18px;
        p {
          margin-right: 30px !important;
        }
      }
    }
    .about-number {
      justify-content: center;
      flex-wrap: wrap;
      .number {
        font-size: 32px !important;
      }
    }
  }
  .about-wrap .container .about-overview {
    display: inline-block;
    margin-bottom: 30px;
    .left {
      width: 100%;
      margin-bottom: 20px;
      font-size: 40px !important;
      line-height: 54px !important;
    }
    .right {
      font-size: 16px !important;
    }
  }
  .en-title {
    font-size: 18px !important;
  }
  .title {
    font-size: 18px !important;
  }
  .item-wrap {
    font-size: 15px !important;
  }
  .ex-item {
    font-size: 14px !important;
    p {
      margin-bottom: 5px !important;
    }
  }
}
</style>